import { ErrorMessage, Field } from "formik";
import { RegistrationFormData, RegistrationStepProps } from "./StepModel";
import clsx from "clsx";
import { Dispatch } from "react";
import { AnyAction } from "redux";
import { ThunkDispatch } from "redux-thunk";
import { sendEmailVerificationCode } from "../RegistrationPageSlice";

export const EmailAddressStep: React.FC<RegistrationStepProps> = ({ currentStep, formikProps }) => (
  <>
    {/* begin::Form group */}
    <div className="fv-row mb-10">
      <label className="form-label fs-6 fw-bolder" htmlFor="emailAddress">
        Email
      </label>
      <Field
        className={clsx(
          "form-control bg-transparent",
          { "is-invalid": formikProps.touched.emailAddress && formikProps.errors.emailAddress },
          {
            "is-valid": formikProps.touched.emailAddress && !formikProps.errors.emailAddress,
          }
        )}
        type="email"
        name="emailAddress"
        autoComplete="off"
        id="emailAddress"
        data-test-id="registration-form__email-input"
      />
      <div className="fv-plugins-message-container">
        <div className="fv-help-block">
          <ErrorMessage name="emailAddress" key={currentStep.toString()} />
        </div>
      </div>
    </div>
    {/* end::Form group */}
  </>
);

export const EmailAddressSubmit = (
  values: RegistrationFormData,
  dispatch: Dispatch<AnyAction>,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  thunkDispatch: ThunkDispatch<any, any, any>
) => {
  thunkDispatch(sendEmailVerificationCode({ emailAddress: values.emailAddress }));
};
